module.exports = __webpack_public_path__ + "static/media/webApps_smallToBig_Adv.6f11eab6.md";